import {ChipProps} from '@mui/material';
import {useRecordContext, useGetOne} from 'react-admin';
import {StatusChip} from '../common/statusChip';

const getChipProps = (status: number): Partial<Omit<ChipProps, 'label'>> => {
    switch (status) {
        case 6:
            return {variant: 'filled', color: 'success'};
        default:
            return {variant: 'filled', color: 'warning'};
    }
};

export const PublisherStatusField = () => {
    const post = useRecordContext();
    const {data} = useGetOne(
        'v1_PublisherPostStatus',
        {id: post?.PublisherStatus},
        {enabled: !!post?.PublisherStatus}
    );
    const label = data?.Status;
    if (!label) return null;
    return (
        <StatusChip
            {...getChipProps(post?.PublisherStatus)}
            label={label}
            sx={{height: '20px'}}
        />
    );
};
